import axios from '@/plugins/axios';
import utils from '@/stores/utils';
import qs from 'qs';

const state = {
    purchaseprices: [],
    purchaseprices_filters: { offset: 0, limit: 20, },
    purchaseprices_count: 0,
    purchaseprices_loading: false,
    purchaseprices_loading_errors: null,
    purchaseprices_cancel_source: null,

};

const mutations = {
    updatePurchasePrices(state, purchaseprices) {
        state.purchaseprices = purchaseprices;
    },
    updatePurchasePricesFilters(state, purchaseprices_filters) {
        state.purchaseprices_filters = purchaseprices_filters;
    },
    updatePurchasePricesCount(state, purchaseprices_count) {
        state.purchaseprices_count = purchaseprices_count;
    },
    updatePurchasePricesLoading(state, loading) {
        state.purchaseprices_loading = loading;
    },
    updatePurchasePricesLoadingErrors(state, errors) {
        state.purchaseprices_loading_errors = errors;
    },
    updatePurchasePricesCancelSource(state, cancel_source) {
        state.purchaseprices_cancel_source = cancel_source;
    },
};

const actions = {

    async fetchPurchasePrices({ commit, dispatch, state }, params) {
        commit('updatePurchasePricesLoading', true);
        commit('updatePurchasePricesLoadingErrors', null);

        if (state.purchaseprices_cancel_source) {
            state.purchaseprices_cancel_source.cancel("canceled");
        }

        const cancelSource = axios.CancelToken.source();
        commit('updatePurchasePricesCancelSource', cancelSource);

        try {
            const response = await axios.get('/api/purchaseprices/', {
                params: state.purchaseprices_filters,
                cancelToken: state.purchaseprices_cancel_source?.token
            });
            commit('updatePurchasePrices', response.data.results);
            commit('updatePurchasePricesCount', response.data.count);
            commit('updatePurchasePricesCancelSource', null);
            return response;
        } catch (xhr_error) {
            if (axios.isCancel(xhr_error)) {
                return;
            }
            let error = utils.handleError(xhr_error);
            commit('updatePurchasePricesLoadingErrors', error.details);
            throw error;
        } finally {
            commit('updatePurchasePricesLoading', false);
        }
    },



};

export default {
    namespaced: true,
    state,
    actions,
    mutations,
};
